import { forwardRef } from "react";
import PropTypes from "prop-types";
import { Skeleton } from "@react-spectrum/s2";

import { usePresignURL } from "@app/hooks/s3";

export const S3Video = forwardRef(
  ({ filePath, src, isLoading: _isLoading, ...props }, ref) => {
    const urlQuery = usePresignURL(filePath, { enabled: !src && !!filePath });
    const videoSrc = urlQuery.data?.presignURL ?? src;

    return (
      <Skeleton isLoading={!!_isLoading || (!videoSrc && urlQuery.isFetching)}>
        <video
          ref={ref}
          src={videoSrc ?? undefined}
          muted
          autoPlay
          playsInline
          loop
          {...props}
        />
      </Skeleton>
    );
  },
);

S3Video.displayName = "S3Video";

S3Video.propTypes = {
  filePath: PropTypes.string,
  src: PropTypes.string,
  isLoading: PropTypes.bool,
};
